<template>
  <div class="container  content-padding  box-bg">
    <div class="container-main">
      <div class="container-main-header">
        <div class="search-box" style="padding-bottom:0px;">
          <div class="index-top-box">
            <font style="font-size:16px" class="index-search-font">智能控制</font><span class="index-top-title"
              style="font-size:16px">/添加控制</span>
          </div>
          <div style="height:16px;"></div>
          <div class="top-opption" style="bottom: 19px;">
            <el-button type="primary" class="step-positon" v-if="form.type != -1" @click="goback1">返回</el-button>
            <el-button type="primary" class="step-positon" v-if="form.type != -1" @click="goTo()">下一步</el-button>
          </div>
        </div>
      </div>
      <div class="equipmentlist box-padding-mide">
        <div class="mudel-left-box">
          <div class="container-content-head">
            <span class="title">添加控制操作</span>
          </div>
          <div class="container-content tablecontent">
            <div class="equipmentcenter">
              <el-steps :active="0" align-center>
                <el-step title="添加控制"></el-step>
                <el-step title="添加触发条件"></el-step>
                <el-step title="添加执行动作"></el-step>
              </el-steps>
            </div>
            <div class="equipmentcenter-step-box">
              <!-- <el-button type="primary" class="step-positon"  @click="goTo()">下一步</el-button>				 -->
            </div>
            <div class="equipmentcenter-opption-box inside-box" style="width:800px;border:none !important;">
              <el-form ref="ruleForm" :rules="rules" :model="form" label-width="160px">
                <el-form-item class="mg-10" label="控制名称：" prop="name">
                  <el-input placeholder="请输入控制名称" v-model="form.name" maxlength="20" clearable></el-input>
                </el-form-item>
                <el-form-item label="控制类型：" prop="type">
                  <el-select v-model="form.type" placeholder="请选择控制类型">
                    <el-option label="自动" value="1"></el-option>
                    <el-option label="定时" value="0"></el-option>
                    <el-option label="手动" value="-1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin:32px 128px;">
                  <el-button type="info" style="width:120px;margin-right:10px;" @click="goback()">取消</el-button>
                  <el-button type="primary" style="width:120px;float:right;" @click="addDevice()">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="mudel-right-box">
          <div class="mudel-right-box-box" style="height: 449px;">
            <div class="container-content-head" style="border-bottom:1px solid #f4f8f9">
              <i class="top-nav"></i><span class="title">词条注释</span>
            </div>
            <div class="mudel-expalin">
              <p>控制类型:1.自动：当满足期望触发条件时，设备自动完成相应操作 。2.定时：通过设定固定时间段、时间点，在此期间设备自动来完成相应操作。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "equipmentcenter",
  components: {

  },
  data() {

    return {
      allgroup: [],
      kztype: "1",
      updatestate: "1",//1：添加 2：编辑
      form: {
        name: '',
        type: "1",
        step: '1',
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入控制名称",
            trigger: "blur"
          }
        ],

        type: [
          {
            required: true,
            message: "请选择控制类型 ",
            trigger: "blur"
          }
        ],
      }
    }
  },
  computed: {},
  filters: {

  },
  methods: {
    filteremojifun(e, name, ruleForm) { //过滤表情
      this.$utils.filteremojifun(this, e, name, ruleForm);
    },
    goback1() {
      this.$router.push({
        name: `intelligentControl`
      });
    },
    goback() {
      this.$router.push({
        name: `intelligentControl0`
      });
    },
    goTo() {
      if (this.updatestate == 1) {//添加
        this.$toaster.error("请先完成当前添加步骤");
        return
      } else {
        if (this.kztype == 1) {//自动
          this.$router.push({
            name: `Linkagecenter4`
          });
        } else if (this.kztype == 0) {//定时
          this.$router.push({
            name: `Linkagecenter2`
          });
        }

      }
    },
    addDevice() {
      sessionStorage.setItem("kztype", this.form.type)
      if (this.updatestate == 1) {//添加			     	
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.$api.device.saveLinkageControl(this.form).then(res => {
              if (res.code == 200) {
                sessionStorage.setItem("projectEditId", res.data);
                this.$toaster.ok("保存成功");
                this.getstate()
              } else {
                this.$toaster.error(res.msg);
              }
            });
          } else {
            this.$toaster.error("保存失败，请先完善信息");
            this.isSaveDraft = false;
            return false;
          }
        });
      } else if (this.updatestate == 2) {//编辑					
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.form.step = 1
            this.$api.device.saveLinkageControl(this.form).then(res => {
              if (res.code == 200) {
                sessionStorage.setItem("projectEditId", res.data);
                this.$toaster.ok("编辑成功");
                this.getstate()
              } else {
                this.$toaster.error(res.msg);
              }
            });
          } else {
            this.$toaster.error("编辑失败，请先完善信息");
            this.isSaveDraft = false;
            return false;
          }
        });
      }
      sessionStorage.setItem("step", "1")
    },
    getDevice(projectEditId) {
      this.$api.device.getControl(projectEditId).then(res => {
        if (res.code == 200) {
          this.form = res.data
          this.form.type = this.form.type.toString()
        } else {
          this.$toaster.error(res.msg);
        }
      });
    },
    getstate() {
      this.kztype = sessionStorage.getItem("kztype");
      var projectEditId = sessionStorage.getItem("projectEditId"); // 获取修改时的项目id
      if (projectEditId == undefined || projectEditId == null) {
        this.updatestate = "1";
        this.form.id = undefined;
      } else {
        this.updatestate = "2";
        this.form.id = projectEditId;
        this.getDevice(projectEditId)
      }
    },

  },
  created() { },
  mounted() {
    this.getstate()
  },
  activated: {

  },
  watch: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.box-padding {
  padding: 20px;
}

.box-bg {
  background: #fff;
}
</style>